import { render } from "./DistancesList.vue?vue&type=template&id=ab718d72"
import script from "./DistancesList.vue?vue&type=script&lang=js"
export * from "./DistancesList.vue?vue&type=script&lang=js"

import "./DistancesList.vue?vue&type=style&index=0&id=ab718d72&lang=css"
script.render = render

export default script